import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, useEffect, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
// material
import {
    Card,
    Table,
    Stack,
    Avatar,
    Button,
    Checkbox,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    TableContainer,
    TablePagination,
    Box,
} from "@mui/material";
// components
import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import Iconify from "../components/Iconify";
import SearchNotFound from "../components/SearchNotFound";
import {
    UserListHead,
    UserListToolbar,
} from "../sections/@dashboard/user";
import Axios from "../axios";

//
import SubscriptionMoreMenu from "../sections/@dashboard/subscription/SubscriptionMoreMenu";
import AddSubscription from "./AddSubscription";
import SubscriptionListToolbar from "../sections/@dashboard/subscription/SubscriptionListToolbar";
import BranchSelect from "./BranchList";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: "", label: "", alignRight: false },
    { id: "name", label: "Subscription Name", alignRight: false },
    { id: "period", label: "Time/Period", alignRight: false },
    { id: "actualPrice", label: "Price", alignRight: false },
    { id: "isDeleted", label: "Deleted", alignRight: false },
    { id: "description", label: "Description", alignRight: false },
    { id: "Branch", label: "Branch", alignRight: false },
    { id: "" },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        return filter(
            array,
            (_subscription) =>
                _subscription.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
        );
    }
    return stabilizedThis.map((el) => el[0]);
}

// Start ------------------------------
export default function Subscriptions() {
    const [page, setPage] = useState(0);
    const [order, setOrder] = useState("asc");
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState("name");
    const [filterName, setFilterName] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [open, setOpen] = useState(false);
    const [menu, setMenu] = useState(false);


    const [subscriptions, setSubscriptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState("")
    const [branchesById, setBranchedById]= useState({})
    useEffect(() => {
        Axios.get(`/api/subscriptions`).then((response) => {
            setSubscriptions(response.data);
        });
    }, [open, menu]);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = subscriptions.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleNewUser = () => {
        setOpen(!open);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleFilterByName = (event) => {
        setFilterName(event.target.value);
    };

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - subscriptions.length) : 0;

    const filteredUsers = applySortFilter(
        subscriptions,
        getComparator(order, orderBy),
        filterName
    );

    const isUserNotFound = filteredUsers.length === 0;

    return (
        <Page title="Subscriptions | My Gym">
            <Container>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={5}
                >
                    <Typography variant="h4" gutterBottom>
                        Subscriptions
                    </Typography>
                    <Container
            sx={{
              display: 'flex',
              flexDirection: 'row',
              
              justifyContent: "flex-end",
              gap: "10px",
              alignItems: 'center', // Vertically aligns items to the center
            }}
          >
      <BranchSelect setBranchedById={setBranchedById} setSelectedBranch={setSelectedBranch} />
                    <Button
                        variant="contained"
                        component={RouterLink}
                        to="#"
                        startIcon={<Iconify icon="eva:plus-fill" />}
                        onClick={handleNewUser}
                    >
                        New Subscription
                    </Button>
                    </Container>
                </Stack>
                <AddSubscription isOpen={open} toggle={handleNewUser} />

                <Card>
                    <SubscriptionListToolbar
                        numSelected={selected.length}
                        filterName={filterName}
                        onFilterName={handleFilterByName}
                    />

                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={TABLE_HEAD}
                                    rowCount={subscriptions.length}
                                    numSelected={selected.length}
                                    onRequestSort={handleRequestSort}
                                    onSelectAllClick={handleSelectAllClick}
                                />
                                <TableBody>
                                    {filteredUsers
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row) => {
                                            const isItemSelected =
                                                selected.indexOf(row.name) !== -1;
                                            return (
                                                (selectedBranch===row.branch || selectedBranch==="") && 
                                                <TableRow
                                                    hover
                                                    key={row._id}
                                                    tabIndex={-1}
                                                    role="checkbox"
                                                    selected={isItemSelected}
                                                    aria-checked={isItemSelected}
                                                >
                                                    <TableCell padding="checkbox">
                                                        <Checkbox
                                                            checked={isItemSelected}
                                                            onChange={(event) =>
                                                                handleClick(event, row.name)
                                                            }
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" padding="none">
                                                        <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            spacing={2}
                                                        >
                                                            <Avatar alt={row.cin} src={row.profilePic} />
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell align="left">{row.name}</TableCell>
                                                    <TableCell align="left">{row.period}</TableCell>
                                                    <TableCell align="left">{row.actualPrice}</TableCell>
                                                    <TableCell align="left">
                                                        {row.isDeleted ? "Yes" : "No"}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.description}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {branchesById[row.branch]}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <SubscriptionMoreMenu subscription={row} menu={menu} setMenu={setMenu} setSubscriptions={setSubscriptions} />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 53 * emptyRows }}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>
                                {isUserNotFound && (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                                                <SearchNotFound searchQuery={filterName} />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={subscriptions.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}
